import { Injectable } from '@angular/core';
import { BaseHttpClientService } from '../../base-http-client.service';
import {BookResponseModel} from '../../../api-models/responses/book/BookResponseModel';

/**
 * گرفتن لیست کتاب ها بر اساس مقطع تحصیلی
 */
@Injectable({
  providedIn: 'root'
})
export class GetBooksService {
  constructor(private baseClient: BaseHttpClientService) {}

  /**
   * @param grade_id آیدی مقطع تحصیلی
   */
  call(grade_id : string) {
      let res = this.baseClient.getWithAuth<BookResponseModel[]>(
          `/api/v1/book/get_books/${grade_id}`
      );

      return res;
  }
}
